import styled from "styled-components";

export const StyledProductSection = styled.section`
  width: 100%;
  padding: 0px 8vw;
  display: flex;
  justify-content: center;

  .area {
    width: 100%;
    padding: 9px 0px 9px 25px;
    gap: 20px 60px;
    min-height: 850px;
    margin: 30px 0px;

    background-color: var(--white);
    display: flex;
    flex-direction: column;
  }
`;
